module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    ref: "goods",
    attrs: {
      "model": _vm.goods,
      "rules": _vm.goodsValidator,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产品名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入产品名称"
    },
    model: {
      value: (_vm.goods.name),
      callback: function($$v) {
        _vm.$set(_vm.goods, "name", $$v)
      },
      expression: "goods.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品描述",
      "prop": "desc"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "描述一下商品吧~~",
      "autosize": {
        minRows: 10,
        maxRows: 20
      }
    },
    model: {
      value: (_vm.goods.desc),
      callback: function($$v) {
        _vm.$set(_vm.goods, "desc", $$v)
      },
      expression: "goods.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品图片",
      "prop": "pictures"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "",
      "http-request": _vm.handleUpload,
      "list-type": "picture-card",
      "multiple": "",
      "accept": "image/*",
      "on-remove": _vm.handleUploadRemove,
      "file-list": _vm.goods.pictures
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店内分类",
      "prop": "tagId"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.goods.tagId),
      callback: function($$v) {
        _vm.$set(_vm.goods, "tagId", $$v)
      },
      expression: "goods.tagId"
    }
  }, _vm._l((_vm.tags), function(tag, index) {
    return _c('el-radio', {
      key: tag.id,
      attrs: {
        "label": tag.id
      }
    }, [_vm._v(_vm._s(tag.name))])
  }), 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/shop/' + _vm.shopId + '/tags'
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_vm._v("管理商品分类")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品价格",
      "prop": "price"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入商品价格"
    },
    model: {
      value: (_vm.goods.price),
      callback: function($$v) {
        _vm.$set(_vm.goods, "price", _vm._n($$v))
      },
      expression: "goods.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品规格类型",
      "label-width": "120px"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.goods.type),
      callback: function($$v) {
        _vm.$set(_vm.goods, "type", $$v)
      },
      expression: "goods.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("单规格")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("多规格")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("复杂规格")])], 1)], 1), _vm._v(" "), (_vm.goods.type === 2) ? _c('div', {
    staticClass: "specs-wrapper"
  }, _vm._l((_vm.goods.specs), function(spec, index) {
    return _c('div', {
      key: spec.key,
      staticClass: "specs-item"
    }, [_c('i', {
      staticClass: "el-icon-delete delete-item",
      on: {
        "click": function($event) {
          return _vm.deleteSameGoods(index)
        }
      }
    }), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "规格",
        "label-width": "60px",
        "prop": 'specs[' + index + '].name',
        "rules": {
          required: true,
          message: '请输入规格的名称',
          trigger: 'blur'
        }
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请填写规格名称"
      },
      model: {
        value: (spec.name),
        callback: function($$v) {
          _vm.$set(spec, "name", $$v)
        },
        expression: "spec.name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "价格",
        "label-width": "60px",
        "prop": 'specs[' + index + '].price',
        "rules": [{
            required: true,
            message: '请输入规格的价格'
          },
          {
            type: 'float',
            message: '价格格式不正确',
            trigger: 'change'
          }
        ]
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "placeholder": "请填写规格价格"
      },
      model: {
        value: (spec.price),
        callback: function($$v) {
          _vm.$set(spec, "price", _vm._n($$v))
        },
        expression: "spec.price"
      }
    })], 1)], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.goods.type === 3) ? _c('div', {
    staticClass: "specs-wrapper"
  }, _vm._l((_vm.goods.specs), function(spec, index) {
    return _c('div', {
      key: spec.key,
      staticClass: "specs-item"
    }, [_c('i', {
      staticClass: "el-icon-delete",
      on: {
        "click": function($event) {
          return _vm.deleteSpecs(index)
        }
      }
    }), _vm._v(" "), _vm._l((spec), function(value, name) {
      return _c('div', [(name === 'Name') ? _c('el-form-item', {
        attrs: {
          "label": "规格",
          "label-width": "120px",
          "rules": {
            required: true,
            message: '请输入规格的名称',
            trigger: 'blur'
          }
        }
      }, [_c('el-input', {
        attrs: {
          "placeholder": "请填写规格名称"
        },
        model: {
          value: (spec.Name),
          callback: function($$v) {
            _vm.$set(spec, "Name", $$v)
          },
          expression: "spec.Name"
        }
      })], 1) : _vm._e(), _vm._v(" "), (name === 'range') ? _c('el-form-item', {
        attrs: {
          "label": "可选个数",
          "label-width": "120px",
          "rules": {
            required: true,
            message: '请输入可选个数',
            trigger: 'blur'
          }
        }
      }, [_c('el-input', {
        attrs: {
          "type": "number",
          "placeholder": "请填写可选个数"
        },
        model: {
          value: (spec.range),
          callback: function($$v) {
            _vm.$set(spec, "range", _vm._n($$v))
          },
          expression: "spec.range"
        }
      })], 1) : _vm._e(), _vm._v(" "), (name === 'required') ? _c('el-form-item', {
        attrs: {
          "label": "是否必须",
          "label-width": "120px"
        }
      }, [_c('el-radio-group', {
        model: {
          value: (spec.required),
          callback: function($$v) {
            _vm.$set(spec, "required", $$v)
          },
          expression: "spec.required"
        }
      }, [_c('el-radio', {
        attrs: {
          "label": "required"
        }
      }, [_vm._v("必须")]), _vm._v(" "), _c('el-radio', {
        attrs: {
          "label": "optional"
        }
      }, [_vm._v("可选")])], 1)], 1) : _vm._e(), _vm._v(" "), (name === 'type') ? _c('el-form-item', {
        attrs: {
          "label": "显示方式",
          "label-width": "120px"
        }
      }, [_c('el-radio-group', {
        model: {
          value: (spec.type),
          callback: function($$v) {
            _vm.$set(spec, "type", $$v)
          },
          expression: "spec.type"
        }
      }, [_c('el-radio', {
        attrs: {
          "label": "radio"
        }
      }, [_vm._v("Radio(单选)")]), _vm._v(" "), _c('el-radio', {
        attrs: {
          "label": "checkbox"
        }
      }, [_vm._v("Checkbox(多选)")])], 1)], 1) : _vm._e(), _vm._v(" "), (name === 'maximum') ? _c('el-form-item', {
        attrs: {
          "label": "最多可选",
          "label-width": "120px",
          "rules": {
            required: true,
            message: '请输入最多可选',
            trigger: 'blur'
          }
        }
      }, [_c('el-input', {
        attrs: {
          "type": "number",
          "placeholder": "请填写最多可选"
        },
        model: {
          value: (spec.maximum),
          callback: function($$v) {
            _vm.$set(spec, "maximum", _vm._n($$v))
          },
          expression: "spec.maximum"
        }
      })], 1) : _vm._e(), _vm._v(" "), (name === 'minimum') ? _c('el-form-item', {
        attrs: {
          "label": "最少可选",
          "label-width": "120px",
          "rules": {
            required: true,
            message: '请输入最少可选',
            trigger: 'blur'
          }
        }
      }, [_c('el-input', {
        attrs: {
          "type": "number",
          "placeholder": "请填写最少可选"
        },
        model: {
          value: (spec.minimum),
          callback: function($$v) {
            _vm.$set(spec, "minimum", _vm._n($$v))
          },
          expression: "spec.minimum"
        }
      })], 1) : _vm._e(), _vm._v(" "), (name === 'maximumEach') ? _c('el-form-item', {
        attrs: {
          "label": "最多每个可选",
          "label-width": "120px",
          "rules": {
            required: true,
            message: '请输入最多每个可选',
            trigger: 'blur'
          }
        }
      }, [_c('el-input', {
        attrs: {
          "type": "number",
          "placeholder": "请填写最多每个可选"
        },
        model: {
          value: (spec.maximumEach),
          callback: function($$v) {
            _vm.$set(spec, "maximumEach", _vm._n($$v))
          },
          expression: "spec.maximumEach"
        }
      })], 1) : _vm._e(), _vm._v(" "), _vm._l((value), function(option, optionIndex) {
        return (name === 'options') ? _c('div', {
          key: optionIndex
        }, [_c('div', {
          staticClass: "delete-option"
        }, [_c('i', {
          staticClass: "el-icon-delete",
          on: {
            "click": function($event) {
              return _vm.deleteOptions(index, optionIndex)
            }
          }
        }), _vm._v(" "), _vm._l((option), function(optionItemValue, optionItemName) {
          return _c('div', [(optionItemName === 'spec') ? _c('el-form-item', {
            attrs: {
              "label": "选项名称",
              "label-width": "100px",
              "rules": {
                required: true,
                message: '请输入规格的名称',
                trigger: 'blur'
              }
            }
          }, [_c('el-input', {
            attrs: {
              "placeholder": "请填写选项名称"
            },
            model: {
              value: (option.spec),
              callback: function($$v) {
                _vm.$set(option, "spec", $$v)
              },
              expression: "option.spec"
            }
          })], 1) : _vm._e(), _vm._v(" "), (optionItemName === 'price') ? _c('el-form-item', {
            attrs: {
              "label": "选项加价",
              "label-width": "100px",
              "rules": [{
                  required: true,
                  message: '请输入规格的价格'
                },
                {
                  type: 'float',
                  message: '价格格式不正确',
                  trigger: 'change'
                }
              ]
            }
          }, [_c('el-input', {
            attrs: {
              "type": "number",
              "placeholder": "请填写选项加价"
            },
            model: {
              value: (option.price),
              callback: function($$v) {
                _vm.$set(option, "price", _vm._n($$v))
              },
              expression: "option.price"
            }
          })], 1) : _vm._e()], 1)
        })], 2)]) : _vm._e()
      }), _vm._v(" "), (name === 'options') ? _c('el-form-item', [_c('el-button', {
        attrs: {
          "icon": "plus",
          "size": "small"
        },
        on: {
          "click": function($event) {
            return _vm.addNewOptions(index)
          }
        }
      }, [_vm._v("添加新的选项")])], 1) : _vm._e()], 2)
    })], 2)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.goods.type > 1) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "icon": "plus",
      "size": "small"
    },
    on: {
      "click": _vm.addNewSpec
    }
  }, [_vm._v("添加新的规格")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('goods')
      }
    }
  }, [_vm._v(_vm._s(this.goodsid ? '更新商品' : '添加商品'))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.reset('goods')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a32aa42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shop/goods-edit.vue
// module id = 813
// module chunks = 1